import React, { useState, useEffect } from "react";
// import axios from "axios";
import {
    Box,
    Typography,
    IconButton,
    DialogActions
} from "@mui/material";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    // Avatar
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { useUser } from "../../hooks/Authorize";
import { useTheme } from "../../style/theme";

export default function RenameDialog({
    openRenameDialog,
    setOpenRenameDialog,
    currentMenuClickedItem,
    newName,
    setNewName,
    items,
    handleRenameSubmit
}) {
    // const platformUser = JSON.parse(localStorage.getItem("user"));
    const [renameError, setRenameError] = useState("");
    // eslint-disable-next-line no-unused-vars
    const [fileBaseName, setFileBaseName] = useState("");
    const [fileExtension, setFileExtension] = useState("");
    const { mode } = useTheme();
 

    useEffect(() => {
        if (currentMenuClickedItem) {
            // Split filename into name and extension
            const lastDotIndex = currentMenuClickedItem.name?.lastIndexOf('.');
            if (lastDotIndex > 0) {
                setFileBaseName(currentMenuClickedItem.name.substring(0, lastDotIndex));
                setFileExtension(currentMenuClickedItem.name.substring(lastDotIndex));
            } else {
                setFileBaseName(currentMenuClickedItem.name);
                setFileExtension("");
            }
            // Initialize newName with the current name
            setNewName(currentMenuClickedItem?.name);
            setRenameError(""); 

        }
    }, [currentMenuClickedItem, setNewName]);



    const handleNameChange = (e) => {
        let inputValue = e.target.value;
        
        // Real-time space handling:
        // 1. Remove spaces at start
        if (inputValue.startsWith(' ')) {
            inputValue = inputValue.replace(/^\s+/, '');
        }
        // 2. Replace multiple spaces with single space
        inputValue = inputValue.replace(/\s+/g, ' ');
        
        // For file extension handling
        const proposedNewName = fileExtension ?
            `${inputValue}${fileExtension}` :
            inputValue;
    
        setNewName(proposedNewName);
    
        // Clean version for validation (additional trim for safety)
        const cleanValue = inputValue.trim();
        const cleanNewName = fileExtension ?
            `${cleanValue}${fileExtension}` :
            cleanValue;
    
        // Validation
        if (!cleanValue) {
            setRenameError("Name cannot be empty");
        } else if (
            items.some(
                (i) =>
                    i.name === cleanNewName &&
                    i._id !== currentMenuClickedItem._id &&
                    i.type === currentMenuClickedItem.type
            )
        ) {
            setRenameError("Name already exists");
        } else if (/[<>:"/\\|?*]/.test(cleanValue)) {
            setRenameError("Invalid characters in name");
        } else {
            setRenameError("");
        }
    };
    
    const handleSubmit = () => {
        // Clean the name before submission
        let cleanName = newName.trim(); // Remove leading/trailing spaces
        cleanName = cleanName.replace(/\s+/g, ' '); // Normalize multiple spaces
        
        // Handle files with extensions
        let finalName = cleanName;
        if (fileExtension) {
            // Remove any spaces immediately before the extension
            const baseName = cleanName.slice(0, -fileExtension.length);
            finalName = `${baseName.replace(/\s+$/, '')}${fileExtension}`;
        }
    
        // Check if name actually changed
        if (finalName === currentMenuClickedItem.name) {
            setOpenRenameDialog(false);
            return;
        }
        
        // Update state with cleaned name
        setNewName(finalName);
        handleRenameSubmit();
    };
    const getDisplayValue = () => {
        if (!currentMenuClickedItem) return "";
        // Show only the base name (without extension) in the input field
        return fileExtension ?
            newName.substring(0, newName.lastIndexOf(fileExtension)) :
            newName;
    };

    return (
        <Dialog
            open={openRenameDialog}
            onClose={() => setOpenRenameDialog(false)}
            PaperProps={{
                sx: {
                    // backgroundColor: "#191919",
                    // background: "rgba(31, 31, 31, 1)",
                    background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

                    // color: "#fff",
                    borderRadius: "12px",
                    padding: "2px",
                    width: "600px",
                    height: "210px",
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: "16px",
                    fontWeight: 600,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                Rename {currentMenuClickedItem?.type === 'file' ? 'File' : 'Folder'}
                <IconButton onClick={() => setOpenRenameDialog(false)} sx={{  }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ paddingBottom: "0px", maxHeight: "75px" }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TextField
                        placeholder="Enter name"
                        value={getDisplayValue()}
                        onChange={handleNameChange}
                        error={Boolean(renameError)}
                        helperText={renameError}
                        sx={{ marginBottom: "0px", height: '40px', flexGrow: 1 }}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                            sx: {
                                // backgroundColor: "#222",
                                backgroundColor: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

                                borderRadius: "8px",
                                // color: "#fff",
                                fontSize: "14px",
                                border: "1px solid rgba(41, 41, 41, 0.5)",
                                "&:hover": {
                                    border: "1px solid rgba(255, 255, 255, 0.4)",
                                },
                                "&.Mui-focused": {
                                    border: "1px solid rgba(255, 255, 255, 0.6)",
                                },
                                "& .MuiInputBase-input": {
                                    padding: "8px 14px",
                                    color: "rgb(86, 86, 86)",
                                },
                            },
                        }}
                    />
                    {fileExtension && (
                        <Typography
                            sx={{
                                ml: 1,
                                color: '#666',
                                fontSize: '14px',
                                minWidth: '40px'
                            }}
                        >
                            {fileExtension}
                        </Typography>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "flex-end", padding: "0px 16px" }}>
                <Button
                    onClick={() => setOpenRenameDialog(false)}
                    sx={{
                        // color: "#fff",
                        textTransform: "none",
                        fontSize: "14px",
                        padding: "6px 12px",
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={!newName || Boolean(renameError)}
                    sx={{
                        backgroundColor: "rgba(55, 103, 177, 1)",
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "6px 16px",
                        textTransform: "none",
                        fontSize: "14px",
                        "&:hover": {
                            backgroundColor: "#1750B6",
                        },
                    }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}